import type { MessengerMessage } from '@/api/client';

export function getDirectMessageLogicalKey(msg: MessengerMessage): string {
  return msg._client?.stableBubbleKey ?? msg.id;
}
